import { useCallback } from 'react'
import { FaultSettings } from '@chilipiper/booking-flow-legacy'
import { History } from 'history'
import { redirect } from '../../../availability/helpers/helpers'

declare global {
  interface Window {
    INTERCOM_MESSENGER_SHEET_LIBRARY?: any
  }
}

export const useFault = (uri: string, history: History) => {
  const fault = useCallback(
    (settings: FaultSettings) => {
      if (settings.inIntercom) {
        window.INTERCOM_MESSENGER_SHEET_LIBRARY.submitSheet({
          error: true,
        })
      }
      let page = settings.page || 'not-available'
      const message = settings.message
      const { search } = window.location
      if (message === 'ProspectMaxMeetingsReached') {
        page = 'max-meetings-reached'
      } else if (message === 'DomainMaxMeetingsReached') {
        page = 'domain-max-meetings-reached'
      }

      const redirectProps = {
        back: () => {
          redirect(history, {
            pathname: `${uri}/calendar`,
          })
        },
        ...(settings.redirectProps ?? {}),
      }

      if (settings.redirect === undefined || settings.redirect) {
        redirect(history, {
          pathname: `${uri}/${page}`,
          search,
          props: redirectProps,
          state: { search },
        })
      }
    },
    [uri, history]
  )
  return { fault }
}
